import React from 'react';
import PropTypes from 'prop-types';
import { get, map, flatten } from 'lodash';
import { Image, SanitizeHtml, Slugify, menuToggler } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
// import { colors } from '../../styles';

const styles = css`
  .Speakers_bannerHeading {
    font-size: 42px;
    font-weight: 700;
    margin: 0 0 90px 0;
    @media (min-width: 992px) {
      font-size: 60px;
    }
  }
  .Speakers_list {
    list-style: none;
    padding: 0;
  }
  .Speakers_listItem {
    margin-bottom: 60px;
    position: relative;
    img {
      border-radius: 100%;
      margin: 0 0 15px 0;
    }
    @media (min-width: 992px) {
      &:nth-child(4n - 1), &:nth-child(4n + 4) {
        .Speaker_bioWrapper {
          right: 0;
          left: auto;
        }
      }
    }
  }
  .Speaker_bioWrapper {
    position: absolute;
    top: 102%;
    width: 90vw;
    max-width: 800px;
    left: 5%;
    z-index: 10;
    padding: 15px;
    background-color: #FFFFFF;
    border: 1px solid #CCC;
    box-shadow: 2px 2px 10px rgba(0,0,0,.2);
    @media (min-width: 992px) {
      width: 60vw;
      padding: 30px;
      left: 0;
    }
  }
  .Speaker_bio {
  }
  .Speaker_button {
    cursor: pointer;
    &:focus {
      outline: 5px solid #DB2150;
      outline-offset: 6px;
    }
  }
  .Speaker_events {
    list-style: none;
    padding: 0;
  }
  .Speaker_eventsItem {
    padding: 0 0 10px 0;
    margin: 0 0 10px 0;
    border-bottom: 1px solid #eeeeee;
    &:last-child {
      border-bottom: 0;
    }
  }
`;

class SpeakerList extends React.Component {

  componentDidMount() {
    if (window.location.hash) {
      this.props.activateMenu(window.location.hash.replace('#', ''))({ target: { setAttribute: () => {} } });
    }
  }

  render() {
    const { speakers, page, activateMenu, isActiveMenu } = this.props;
    const events = flatten(map(flatten(map(get(page, 'schedule[0].days'), 'times')), 'event'));
    return (
      <div className={styles}>
        <h1 className="Speakers_bannerHeading">Homebuilder Tech Speakers</h1>
        <ul className="Speakers_list row">
          {speakers.map(speaker => {
            const speakerEvents = events.filter(event => map(event.speakers, 'speaker').includes(speaker._id));
            return (
              <li key={speaker._id} className={`Speakers_listItem col-lg-3 text-center ${isActiveMenu(Slugify(speaker.name)) ? 'Speakers_listItem-active' : ''}`} id={Slugify(speaker.name)}>
                <div className="Speaker_button" role="button" tabIndex="0" onClick={activateMenu(Slugify(speaker.name))}>
                  <Image
                    src={get(speaker, 'headshot.contentUrl')}
                    alt={speaker.name}
                    width={200}
                    height={200}
                    exact
                  />
                  <h6>
                    <strong>{speaker.name}</strong><br />
                    {speaker.title && <span>{speaker.title}<br /></span>}
                    {speaker.company}
                  </h6>
                </div>
                {
                  isActiveMenu(Slugify(speaker.name)) &&
                  (
                    get(speaker, 'bio')
                    || speakerEvents.length > 0
                  ) &&
                  <div className="Speaker_bioWrapper">
                    {
                      get(speaker, 'bio') &&
                      <div className="Speaker_bio text-left" dangerouslySetInnerHTML={SanitizeHtml(get(speaker, 'bio'))} />
                    }
                    {
                      speakerEvents.length > 0 &&
                      <div className="text-left">
                        <h4>Speaking Sessions</h4>
                        <ul className="Speaker_events">
                          {
                            speakerEvents.map(event => (
                              <li key={event._id} className="Speaker_eventsItem">
                                <Link name="agenda" hash={`#${Slugify(event.title)}`}>{event.title}</Link>
                              </li>
                            ))
                          }
                        </ul>
                      </div>
                    }
                  </div>
                }
              </li>
            );
          },
        )}
        </ul>
      </div>
    );
  }
}

SpeakerList.propTypes = {
  speakers: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.object.isRequired,
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
};

export default withData({ page: 'agenda' })(menuToggler(SpeakerList));



// WEBPACK FOOTER //
// ./src/pages/Speakers/SpeakersList.js